import { useToken } from "@gluestack-style/react";
import { Box, Button, HStack, Image } from "components/ui";
import { H4, Typography } from "components/ui/Typography";
import { FileText } from "lucide-react-native";
import React from "react";

type Props = {
	title: string;
	type: "web" | "blog" | "faq";
};
const WebContentItem = ({ title, type }: Props) => {
	const contentType = type === "web" ? "|  Web Page" : type === "blog" ? "|  Blog" : "|  FAQ's";
	const resolvedPrimaryLight = useToken("colors", "primarylight");
	return (
		<Box flexDirection="row" paddingHorizontal={20} paddingVertical={20}>
			<HStack gap={12} marginRight={"auto"}>
				<FileText size={24} color={resolvedPrimaryLight} />
				<Typography>{title}</Typography>
				<Typography sx={{ color: "$neutral500" }}>{contentType}</Typography>
			</HStack>
		</Box>
	);
};

export default WebContentItem;
